import React, { createContext, useState } from "react";

export const TicketContext = createContext();

export default function CreateTicketContext({ children }) {
  const [createTicket, setCreateTicket] = useState(false);
  return (
    <TicketContext.Provider value={{ createTicket, setCreateTicket }}>
      {children}
    </TicketContext.Provider>
  );
}
